import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'index',
		component: () => import('../views/index.vue'),
		meta:{
			  title:"潍坊市单病种群体管理实时数据",
			  zhTitle:"潍坊市单病种群体管理实时数据"
		}
	},
	{
		path: '/indexaq',
		name: 'indexaq',
		component: () => import('../views/index-aqindex.vue'),
		meta:{
			  title:"三高共管六病同防管理",
			  zhTitle:"三高共管六病同防管理"
		}
	},
	{
		path: '/indexother',
		name: 'indexother',
		component: () => import('../views/index-other.vue'),
		meta:{
			  title:"三高共管六病同防管理",
			  zhTitle:"三高共管六病同防管理"
		}
	},
	{
		path: '/indexaqother',
		name: 'indexaqother',
		component: () => import('../views/index-aq.vue'),
		meta:{
			  title:"潍坊市单病种群体管理实时数据",
			  zhTitle:"潍坊市单病种群体管理实时数据"
		}
	},
	{
		path: '/sggl',
		name: 'sggl',
		component: () => import('../views/index-gl.vue'),
		meta:{
			  title:"三高共管六病同防管理",
			  zhTitle:"三高共管六病同防管理"
		}
	}
]
const router = new VueRouter({
	mode: "history",
	routes
})


router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) {//判断是否有标题
		// @ts-ignore
		document.title = to.meta.title
	}
	next()//执行进入路由，如果不写就不会进入目标页
})

export default router
